import React, { FC, useEffect } from "react";
import { createUseStyles } from "react-jss";
import styles from "./styles";
import { LOCATION_MODULES } from "../../constants";

interface Props {
  isCif: boolean;
  closeModal?: () => void; // gets injected from the Modal HOC //
  onFormCompleted?: () => void;
  onPersonalizationCompleted?: () => void;
  locId: string | number;
  instId: string | number;
  tourId: string;
  typeId: string;
  userKey: string | number;
  sessionId: string | number;
  token: string;
  formType: string;
}

const CIF: FC<Props> = (props: Props) => {
  const {
    isCif,
    instId,
    locId,
    tourId,
    typeId,
    userKey,
    sessionId,
    token,
    formType,
    closeModal,
    onFormCompleted,
    onPersonalizationCompleted,
  } = props;

  // Styles //
  const useStyles = createUseStyles(styles);
  const classes = useStyles(styles);

  // legacy form url //
  const legacyForm = `${process.env.REACT_APP_API_BASE_URL}/registration/${instId}/${locId}?tourid=${tourId}&isMap=1&?typeid=${typeId}`;

  // cif url //
  const cifForm = `${process.env.REACT_APP_API_BASE_URL}registration-app/latest/index.html#/${instId}/${locId}?cif=1&inst_id=${instId}&loc_id=${locId}&tourid=${tourId}&userkey=${userKey}&source=web&original_source=web&formType=${formType}&sessionid=${sessionId}&embed=1&embed_type=virtual-tour&typeid=${typeId}&token=${token}&module_id=${LOCATION_MODULES.FULL_MAP}`;

  // close form when it's completed //
  useEffect(() => {
    const regFormListener = (e) => {
      const formData = e.data;
      if (formData.message === "RegistrationForm_Completed") {
        onFormCompleted();
      } else if (formData.message === "RegistrationForm_Dismissed") {
        closeModal();
      }
      if (
        (formData?.message &&
          formData?.message?.includes(":::personalization")) ||
        formData.includes(":::personalization")
      ) {
        onPersonalizationCompleted();
      }
    };

    window.addEventListener("message", regFormListener);
    return () => {
      window.removeEventListener("message", regFormListener);
    };
  }, [closeModal, onFormCompleted, onPersonalizationCompleted]);

  return (
    <iframe
      className={`${classes.iframeContainer} ${isCif ? "" : classes.legacy}`}
      title="Registration Form"
      src={isCif ? cifForm : legacyForm}
      data-testid="cif-form"
    />
  );
};

CIF.defaultProps = {
  closeModal: Function,
  onFormCompleted: Function,
  onPersonalizationCompleted: Function,
};

export default CIF;
